import { Route, Routes, useSearchParams } from 'react-router-dom'

import { leagacyRouteMap } from './legacy-routes-map'

const addLocaleParams = (newPath: string): string => {
  const originParameter = new URLSearchParams(window.location.search)
  const url = new URL(process.env.REACT_APP_HOST + newPath)
  const localeParam = originParameter.get('locale')

  if (localeParam) {
    url.searchParams.set('locale', localeParam)
  }

  return url.toString()
}

const RedirectTerms = () => {
  const currPath = window.location.pathname
  const newPath =
    leagacyRouteMap['terms'][currPath] !== undefined ? leagacyRouteMap['terms'][currPath] : '/policies/terms-conditions/latest'

  const originParameter = new URLSearchParams(window.location.search)
  const url = new URL(process.env.REACT_APP_HOST + newPath)
  originParameter.forEach((value, key) => {
    url.searchParams.set(key, value)
  })

  window.location.href = url.toString()

  return null
}

const RedirectProfile = () => {
  const currPath = window.location.pathname
  const newPath = leagacyRouteMap['profile'][currPath] !== undefined ? leagacyRouteMap['profile'][currPath] : '/dashboard/profile'

  window.location.href = addLocaleParams(newPath)

  return null
}

const RedirectGuide = () => {
  const currPath = window.location.pathname

  const newPath =
    leagacyRouteMap['guide'][currPath] !== undefined
      ? leagacyRouteMap['guide'][currPath]
      : '/guide/two-step-verification/introduction'

  window.location.href = process.env.REACT_APP_HOST + newPath

  return null
}

const RedirectSecurity = () => {
  const currPath = window.location.pathname
  const newPath =
    leagacyRouteMap['security'][currPath] !== undefined ? leagacyRouteMap['security'][currPath] : '/dashboard/security'

  window.location.href = process.env.REACT_APP_HOST + newPath

  return null
}

const RedirectNotice = () => {
  const currPath = window.location.pathname
  const newPath = leagacyRouteMap['notice'][currPath] !== undefined ? leagacyRouteMap['notice'][currPath] : '/notices'

  window.location.href = addLocaleParams(newPath)

  return null
}

const RedirectEtc = () => {
  const currPath = window.location.pathname

  const newPath = leagacyRouteMap['etc'][currPath] !== undefined ? leagacyRouteMap['etc'][currPath] : '/notices'

  window.location.href = addLocaleParams(newPath)

  return null
}

const RedirectScloud = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/services/scloud'
  return null
}

const RedirectServices = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/services'
  return null
}

const RedirectFamily = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/family'
  return null
}

const RedirectPrivacy = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/privacy'
  return null
}

const RedirectPlace = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/places'
  return null
}

const RedirectDevice = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/devices'
  return null
}

const RedirectContents = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard'
  return null
}

const RedirectPP = () => {
  window.location.href = process.env.REACT_APP_HOST + '/policies/privacy-notices/latest'
  return null
}

const RedirectPolicyCookie = () => {
  window.location.href = process.env.REACT_APP_HOST + '/policies/cookie'
  return null
}

const RedirectPolicyTerms = () => {
  window.location.href = process.env.REACT_APP_HOST + '/policies/terms-conditions/latest'
  return null
}

const RedirectSpecialTerms = () => {
  const [params] = useSearchParams()
  window.location.href = process.env.REACT_APP_HOST + '/policies/specials/' + params.get('fileName')
  return null
}

const RedirectLanguage = () => {
  window.location.href = process.env.REACT_APP_HOST + '/language'
  return null
}

const RedirectToRoot = () => {
  window.location.href = process.env.REACT_APP_HOST + '/dashboard/intro'
  return null
}

const RedirectOperatorPolicy = () => {
  const originParameter = new URLSearchParams(window.location.search)
  const url = new URL(process.env.REACT_APP_HOST + '/policies/privacy-notices/operators')
  originParameter.forEach((value, key) => {
    url.searchParams.set(key, value)
  })

  window.location.href = url.toString()
  return null
}

const RedirectPolicyPrivacy = () => {
  window.location.href = process.env.REACT_APP_HOST + '/policies/privacy-notices/latest'
  return null
}

const RedirectPdp = () => {
  window.location.href = process.env.REACT_APP_HOST + '/policies/privacy-notices/latest'
  return null
}

export default function DashboardRoutes() {
  return (
    <Routes>
      <Route>
        <Route path='/guide/2step/help' element={<RedirectGuide />} />
        <Route path='/guide/2step/*' element={<RedirectGuide />} />
        <Route path='/guide/setup-2step-verification' element={<RedirectGuide />} />
        <Route path='/guide/setup-authenticator-app' element={<RedirectGuide />} />
        <Route path='/guide/sign-in-using-verification-codes' element={<RedirectGuide />} />
        <Route path='/notice/notice-list' element={<RedirectNotice />} />
        <Route path='/notice/list' element={<RedirectNotice />} />
        <Route path='/notice*' element={<RedirectNotice />} />
        <Route path='/terms*' element={<RedirectTerms />} />
        <Route path='/contents/profile*' element={<RedirectProfile />} />
        <Route path='/contents/security*' element={<RedirectSecurity />} />
        <Route path='/contents/scloud*' element={<RedirectScloud />} />
        <Route path='/contents/services*' element={<RedirectServices />} />
        <Route path='/contents/family*' element={<RedirectFamily />} />
        <Route path='/contents/privacy*' element={<RedirectPrivacy />} />
        <Route path='/contents/place*' element={<RedirectPlace />} />
        <Route path='/contents/device*' element={<RedirectDevice />} />
        <Route path='/contents*' element={<RedirectContents />} />
        <Route path='/pp*' element={<RedirectPP />} />
        <Route path='/policy/privacy/operator-list' element={<RedirectOperatorPolicy />} />
        <Route path='/policy/privacy' element={<RedirectPolicyPrivacy />} />
        <Route path='/policy/cookie' element={<RedirectPolicyCookie />} />
        <Route path='/policy/terms*' element={<RedirectPolicyTerms />} />
        <Route path='/etc/specialTC.do' element={<RedirectSpecialTerms />} />
        <Route path='/language' element={<RedirectLanguage />} />
        <Route path='/etc*' element={<RedirectEtc />} />
        <Route path='/pdp*' element={<RedirectPdp />} />
        <Route path='/index*' element={<RedirectToRoot />} />
        <Route path='/intro*' element={<RedirectToRoot />} />
        <Route path='*' element={<RedirectToRoot />} />
      </Route>
    </Routes>
  )
}
